
     <form [formGroup]="formEdit" >
     <mat-dialog-content>
       <div [hidden] = "type !== 'QR'">
        <qrcode [width]='256' [qrdata]='UID' [errorCorrectionLevel]="'M'"></qrcode>
       </div>
       <div [hidden] = "type === 'QR'">
        <ngx-barcode [bc-value]="UID" [bc-format]="type === 'QR' ? '' : type" [bc-display-value]="true"></ngx-barcode>
       </div>
     </mat-dialog-content>
    </form>
  